import WebpageAdd from '../components/WebpageAdd.vue';
import WebpageList from '../components/WebpageList';
import WebpageEdit from '../components/WebpageEdit.vue';
import ImageRegion from '../components/ImageRegion.vue';
import IntelligentBaselineResult from '../components/IntelligentBaselineResult.vue';
import ResponsePerformance from '../components/ResponsePerformance.vue';

export default [
  {
    path: '',
    redirect: 'list',
    role: ['User']
  },
  {
    path: 'list',
    component: WebpageList,
    meta: {
      title: 'Webpages',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/webpages',
          title: 'Webpages'
        },
        {
          path: '/list',
          title: 'View Webpages'
        }
      ]
    }
  },
  {
    path: 'add',
    component: WebpageAdd,
    meta: {
      title: 'Add Webpage',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/webpages',
          title: 'Webpages'
        },
        {
          path: '/add',
          title: 'Add Webpage'
        }
      ]
    }
  },
  {
    path: ':id',
    component: WebpageEdit,
    meta: {
      title: 'Edit Webpage',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/webpages',
          title: 'Webpages'
        },
        {
          path: '',
          title: 'Edit Webpage Configuration'
        }
      ]
    }
  },
  {
    path: ':id/response-performance',
    component: ResponsePerformance,
    meta: {
      title: 'Response Performance',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/webpages',
          title: 'Webpages'
        },
        {
          path: '/webpages',
          title: 'View Webpages',
          isDisplayId: true
        },
        {
          path: '',
          title: 'Response Performance'
        }
      ]
    }
  },
  {
    path: ':id/image-region',
    component: ImageRegion,
    meta: {
      title: 'Edit Configuration',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/webpages',
          title: 'Webpages'
        },
        {
          path: '/webpages',
          title: 'View Webpages',
          isDisplayId: true
        },
        {
          path: '',
          title: 'Edit Configuration'
        }
      ]
    }
  },
  {
    path: 'baseline-result/:id',
    component: IntelligentBaselineResult,
    meta: {
      title: 'Baseline Result',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/webpages',
          title: 'Webpages'
        },
        {
          path: '',
          title: 'Baseline Result'
        }
      ]
    }
  }
];
